import React from 'react';
import { Grid } from '@wegroup/design-system';

// Components
import SingleSelectDetailedInput from './SingleSelectDetailedInput';

// Types
import TextError from '../../../ui/advisory-flow/components/shared-components/TextError';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import useQuestionEnum from '../../../../hooks/useQuestionEnum';

interface Props {
  question: FlowsQuestion;
}

const SelectDetailedInputComponent: React.FC<
  React.PropsWithChildren<Props>
> = ({ question }) => {
  const {
    field: { onBlur, value },
    error,
  } = useFlowInputComponent({ question });

  const options = useQuestionEnum(question);

  const handleOnSelected = (enumKey: string) => {
    if (enumKey === value) onBlur({ name: question.id, value: undefined });
    else onBlur({ name: question.id, value: enumKey });
  };

  return (
    <>
      <TextError
        error={error?.message}
        data-test-id="ProdFac_SelectDetailedInputComponent_Error"
      />
      <Grid
        templateColumns={`repeat(auto-fit, 18rem)`}
        gridGap="2.4rem"
        width="100%"
        justifyContent="center"
        data-test-id="ProdFac_SelectDetailedInputComponent"
      >
        {options.map(({ label, value: _value }) => (
          <SingleSelectDetailedInput
            key={label + _value}
            icon={_value as string}
            title={label}
            value={value === _value}
            onSelected={() => handleOnSelected(_value as string)}
          />
        ))}
      </Grid>
    </>
  );
};

export default SelectDetailedInputComponent;
